"use server";

import bcrypt from "bcryptjs";
import { prisma } from "@/lib/db";
import { audit } from "@/lib/audit";
import { registerSchema } from "@/lib/validation/auth-schemas";

export interface RegisterResult {
  ok: boolean;
  error?: string;
  fieldErrors?: Record<string, string[]>;
}

export async function registerAction(formData: FormData): Promise<RegisterResult> {
  const raw = {
    email: formData.get("email"),
    password: formData.get("password"),
    name: formData.get("name") || undefined,
  };
  const parsed = registerSchema.safeParse(raw);
  if (!parsed.success) {
    return { ok: false, fieldErrors: parsed.error.flatten().fieldErrors };
  }
  const { email, password, name } = parsed.data;

  const existing = await prisma.user.findUnique({ where: { email } });
  if (existing) {
    // Generic message to avoid email enumeration
    return { ok: false, error: "Could not create account with that email." };
  }

  const passwordHash = await bcrypt.hash(password, 12);
  const user = await prisma.user.create({
    data: { email, passwordHash, name, role: "PATIENT" },
  });
  await audit({
    action: "LOGIN_SUCCESS",
    actorId: user.id,
    subjectId: user.id,
    metadata: { event: "account_created" },
  });
  return { ok: true };
}
